(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.lastFocusedElement = null
    this.addEventListener('click', this.onClick.bind(this))
    this.addEventListener('change', this.onQuantityInputChange.bind(this))
    this.boundOnKeydown = this.onKeydown.bind(this)
    document.addEventListener('keydown', this.boundOnKeydown)
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.boundOnKeydown)
  }

  onClick(event) {
    const closeTarget = event.target.closest('[data-cart-drawer-close]')
    if (closeTarget) {
      // A link that also closes the drawer ("Shop all") still has to navigate
      if (!closeTarget.matches('a[href]')) event.preventDefault()
      this.close()
      return
    }

    const qtyButton = event.target.closest('[data-cart-qty-btn]')
    if (qtyButton) {
      event.preventDefault()
      const item = qtyButton.closest('[data-cart-item]')
      const input = item.querySelector('[data-cart-qty-input]')
      const currentValue = parseInt(input.value, 10) || 0
      const nextValue = qtyButton.dataset.action === 'increment'
        ? currentValue + 1
        : Math.max(0, currentValue - 1)
      input.value = nextValue
      this.updateLine(item.dataset.key, nextValue)
      return
    }

    const removeButton = event.target.closest('[data-cart-remove]')
    if (removeButton) {
      event.preventDefault()
      const item = removeButton.closest('[data-cart-item]')
      this.updateLine(item.dataset.key, 0)
    }
  }

  onQuantityInputChange(event) {
    const input = event.target.closest('[data-cart-qty-input]')
    if (!input) return
    const item = input.closest('[data-cart-item]')
    const value = Math.max(0, parseInt(input.value, 10) || 0)
    this.updateLine(item.dataset.key, value)
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close()
    }
  }

  open() {
    this.lastFocusedElement = document.activeElement
    this.classList.add('is-open')
    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('cart-drawer-open')
    const closeButton = this.querySelector('.cart-drawer__close')
    if (closeButton) closeButton.focus()
  }

  close() {
    this.classList.remove('is-open')
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('cart-drawer-open')
    if (this.lastFocusedElement) this.lastFocusedElement.focus()
  }

  async updateLine(key, quantity) {
    this.classList.add('is-loading')
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      })
      if (!response.ok) throw new Error('Unable to update bag')
    } catch (error) {
      console.error(error)
    } finally {
      await this.refresh()
      this.classList.remove('is-loading')
    }
  }

  async refresh() {
    const response = await fetch(window.location.pathname + '?section_id=cart-drawer')
    const html = await response.text()
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const updatedDrawer = doc.querySelector('cart-drawer')
    if (!updatedDrawer) return

    this.innerHTML = updatedDrawer.innerHTML
    const itemCount = parseInt(updatedDrawer.dataset.itemCount || '0', 10)
    this.dataset.itemCount = String(itemCount)
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount } }))
  }
}

customElements.define('cart-drawer', CartDrawer)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
// Quantity stepper +/- buttons
document.querySelectorAll('.cart__qty-stepper').forEach(function(stepper) {
  stepper.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart__qty-btn');
    if (!btn) return;
    var input = stepper.querySelector('.cart__qty-input');
    var val = parseInt(input.value, 10) || 0;
    if (btn.dataset.action === 'increment') {
      input.value = val + 1;
    } else if (btn.dataset.action === 'decrement' && val > 0) {
      input.value = Math.max(0, val - 1);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', function (event) {
  var cartLink = event.target.closest('[data-cart-icon-bubble]')
  if (!cartLink) return

  var drawer = document.querySelector('cart-drawer')
  if (!drawer) return

  event.preventDefault()
  customElements.whenDefined('cart-drawer').then(function () {
    drawer.open()
  })
})

const HEADER_DESKTOP_QUERY = window.matchMedia('(min-width: 1241px)')

function setHeaderMenuOpen(isOpen) {
  const toggle = document.querySelector('[data-menu-toggle]')
  const menu = document.getElementById('site-menu')
  if (!toggle || !menu) return

  toggle.setAttribute('aria-expanded', isOpen)
  menu.toggleAttribute('data-open', isOpen)
}

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]')
  if (toggle) {
    setHeaderMenuOpen(toggle.getAttribute('aria-expanded') !== 'true')
    return
  }

  if (!event.target.closest('.site-header')) setHeaderMenuOpen(false)
})

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return

  setHeaderMenuOpen(false)
  document.querySelector('[data-menu-toggle]')?.focus()
})

HEADER_DESKTOP_QUERY.addEventListener('change', function (event) {
  if (event.matches) setHeaderMenuOpen(false)
})

document.addEventListener('cart:updated', function (event) {
  var count = event.detail.itemCount
  var badge = document.querySelector('[data-cart-count]')
  var cartLink = document.querySelector('[data-cart-icon-bubble]')

  if (badge) {
    badge.textContent = count
    badge.hidden = count === 0
  }

  if (cartLink) {
    cartLink.setAttribute('aria-label', 'Cart, ' + count + ' ' + (count === 1 ? 'item' : 'items'))
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
// A link such as /pages/contact?message=… (the product page's enquiry button) pre-fills the message
const contactMessage = document.getElementById('ContactMessage')
const prefilledMessage = new URLSearchParams(window.location.search).get('message')

if (contactMessage && prefilledMessage && contactMessage.value.trim() === '') {
  contactMessage.value = prefilledMessage
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide-tabs"] && !Shopify.designMode) return;
  try {
    
const SIZE_GUIDE_NUMBER_PATTERN = /^\d+(\.\d+)?$/
const CENTIMETRES_PER_INCH = 2.54

class SizeGuide extends HTMLElement {
  connectedCallback() {
    this.unitButtons = [...this.querySelectorAll('[data-unit]')]

    // Remember each measurement in centimetres so switching units never compounds rounding
    this.measurementCells = [...this.querySelectorAll('td, .size-table__value')].filter((cell) =>
      SIZE_GUIDE_NUMBER_PATTERN.test(cell.textContent.trim())
    )
    this.measurementCells.forEach((cell) => {
      cell.dataset.centimetres = cell.textContent.trim()
    })

    this.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    const unitButton = event.target.closest('[data-unit]')
    if (unitButton) this.selectUnit(unitButton.dataset.unit)
  }

  selectUnit(unit) {
    this.unitButtons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.unit === unit)
    })
    this.measurementCells.forEach((cell) => {
      cell.textContent = unit === 'in' ? formatInches(Number(cell.dataset.centimetres)) : cell.dataset.centimetres
    })
  }
}

function formatInches(centimetres) {
  return String(Math.round((centimetres / CENTIMETRES_PER_INCH) * 10) / 10)
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}

  } catch(e) { console.error(e); }
})();
})();
